<template lang="pug">
  .color-kit-imagery-carousel(v-if="product.id")
    PdpCarousel(:images="product.imagery.pdpCarouselLarge")
      template(v-slot:first-image)
        .ribbon-wrap
          p.ribbon.upper.semi-bold.xs-f-small.max-at-tweak(v-if="product.inventory_status == 'coming_soon'") coming soon
          p.ribbon.upper.semi-bold.xs-f-small.max-at-tweak(v-else-if="product.inventory_status == 'backordered'") backordered
          p.ribbon.purple.upper.semi-bold.xs-f-small.max-at-tweak(v-else-if="product.new") new
      template(v-if="advisorComplete")
        .playground-ctas.xs-f-xxsmall.max-at-tweak
          button.try-it.btn-reset.color-white.upper.xs-f-xxsmall.max-at-tweak(type="button" ref="tryItOn" @click="seeMoreColors(false, $refs.tryItOn)" data-mr-ass="try-it-on")
            span.non-focusable(tabindex="-1") try it on

</template>

<script>
  import { mapActions } from 'vuex';
  import PdpCarousel from '../../PdpCarousel';

  export default {
    name: "ColorKitImageryCarousel",

    components: {
      PdpCarousel
    },

    props: {
      product: {
        type: Object,
        default: {}
      }
    },

    computed: {
      advisorComplete() {
        return this.$root.advisorComplete;
      }
    },

    methods: {
      ...mapActions('pdp', ['openPlaygroundModal']),

      seeMoreColors(viewOnModel, elementRef) {
        this.openPlaygroundModal({
          props: {
            viewOnModel: viewOnModel
          },
          returnFocusElement: elementRef
        });
      }
    }
  }
</script>

<style scoped lang="stylus">
  .color-kit-imagery-carousel
    .ribbon-wrap
      position absolute
      top 0
      left 0
      width 10em
      height 10em
      overflow hidden
      
      
    .ribbon
      position absolute
      transform translate3D(-50%, -50%, 0) rotate(-45deg)
      top 4em
      left 4em
      background-color #d8e3f2
      padding 0.5em 3em
      min-width 15em
      text-align center
      
      &.purple
        background-color color-mr-purple
        color color-white
            
    >>> .playground-ctas
      position absolute
      right 1em
      bottom 1.25em
      width 6em
      text-align center
      
      .try-it
        display inline-block
        width 5.5em
        height 5.5em
        border-radius 50%
        border 1px solid color-white
        background-color color-mr-purple
        text-align center
        color color-white
        
        .non-focusable
          width 100%
          height 100%
          padding 0.5em
          padding-top 1.2em
          line-height 1.4em
          padding-top 1.5em
        
</style>
